module.exports = __webpack_public_path__ + "static/media/ic-twitter.6f887cf1.svg";